'use strict';

require('./services/hdlPlugins');
require('./../resources/sass/cloud.scss');

const jQuery = require('jquery');

require('spectrum-colorpicker');
require('customevent');
require('phantomjs-polyfill-string-includes');
require('ie-array-find-polyfill');
require('custom-event-polyfill');

import 'babel-polyfill';

const start = function() {
    let $toolbar = jQuery('#cloud-ui');
    const ConfigHandler = require('./core/configHandler');
    const container = require('./core/container');
    const device = require('./services/device');
    const requestHandler = require('./core/requestHandler');

    require('./expose');

    require('./core/translator').init();

    requestHandler.setBaseUrl('/rest/2');

    require('./services/jPlugins');

    container.set('$toolbar', $toolbar);
    container.set('$siteWrapper', jQuery('#bb-site-wrapper'));

    container.set('isMobile', device.isMobile());

    ConfigHandler.init(require('./config'));

    jQuery.noConflict();

    // Reload page after back button pressed
    if(!!window.performance && window.performance.navigation.type === 2) {
        window.location.reload();
    }

    container.set('getResourceUrl', (path) => {
        return ($toolbar.data('image-domain') || '') + (`/${path}`.replace('//', '/'));
    });

    document.dispatchEvent(new CustomEvent('cloudReady', {}));
};

if (document.readyState === 'complete' || document.readyState === 'loaded') {
    start();
} else {
    jQuery(document).ready(start);
}
